export default (state = null, action) => {
    return action;
};


// WEBPACK FOOTER //
// ./src/store/Action.js